import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'career_listing_repeatable',
    props: ['d'],
    setup(__props) {
        const props = __props;
        function getCareerListingData() {
            let careerData = [];
            for (const career of props.d.career_listing_repeatable) {
                careerData.push({
                    title: career.title
                });
            }
            return {
                title: 'Available Positions:',
                leadin: null,
                careers: careerData
            };
        }
        return (_ctx, _cache) => {
            const _component_career_listing = _resolveComponent("career-listing");
            return (_openBlock(), _createElementBlock("div", null, [
                _createVNode(_component_career_listing, {
                    d: getCareerListingData()
                }, null, 8, ["d"])
            ]));
        };
    }
});
